import axios from "../utils/AxiosInstance";
import { ResponseMessage } from "../models/ResponseMessage";
import { Constants } from "../constants/constants";
import {
  Client,
  CreateClientRequest,
  UpdateClientRequest,
  BulkImportResult,
  BulkImportConfirmRequest,
} from "../models/ClientModels";
import { PagedResult } from "../models/PagedModels";

const API_BASE_URL = Constants.API_BASE_URL;

export interface ClientListQuery {
  page?: number;
  pageSize?: number;
  search?: string;
  isActive?: boolean;
}

export async function getClientsByOrganizationAsync(
  token: string,
  organizationId: string,
  query: ClientListQuery = {},
): Promise<ResponseMessage<PagedResult<Client>>> {
  const response = await axios.get(
    `${API_BASE_URL}/clients/organization/${organizationId}`,
    {
      params: {
        page: query.page,
        pageSize: query.pageSize,
        search: query.search,
        isActive: query.isActive,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return ResponseMessage.fromJson(response.data);
}

export async function getClientByPhoneAsync(
  token: string,
  phone: string,
): Promise<ResponseMessage<Client>> {
  const response = await axios.get(
    `${API_BASE_URL}/clients/phone/${encodeURIComponent(phone)}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return ResponseMessage.fromJson(response.data);
}

export async function createClientAsync(
  token: string,
  client: CreateClientRequest,
): Promise<ResponseMessage<Client>> {
  const response = await axios.post(`${API_BASE_URL}/clients`, client, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return ResponseMessage.fromJson(response.data);
}

export async function updateClientAsync(
  token: string,
  id: string,
  client: UpdateClientRequest,
): Promise<ResponseMessage<Client>> {
  const response = await axios.put(`${API_BASE_URL}/clients/${id}`, client, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return ResponseMessage.fromJson(response.data);
}

export async function deleteClientAsync(
  token: string,
  id: string,
): Promise<ResponseMessage<boolean>> {
  const response = await axios.delete(`${API_BASE_URL}/clients/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return ResponseMessage.fromJson(response.data);
}

export async function bulkValidateClientsAsync(
  token: string,
  organizationId: string,
  file: File,
): Promise<ResponseMessage<BulkImportResult>> {
  const formData = new FormData();
  formData.append("file", file);

  const response = await axios.post(
    `${API_BASE_URL}/clients/bulk-validate/${organizationId}`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    },
  );

  return ResponseMessage.fromJson(response.data);
}

export async function bulkImportClientsAsync(
  token: string,
  request: BulkImportConfirmRequest,
): Promise<ResponseMessage<BulkImportResult>> {
  const response = await axios.post(
    `${API_BASE_URL}/clients/bulk-import`,
    request,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return ResponseMessage.fromJson(response.data);
}